import PropTypes from "prop-types"
import React from "react"
import { getPaymentStatusBadgeProps } from "src/main/Billing/Payments/PaymentStatusBadge"

import Badge from "src/components/Badge"
import Button from "src/components/Button"
import SideSheet from "src/components/SideSheet"
import Tooltip from "src/components/Tooltip"

import { useCopyToClipboard } from "src/hooks/use_copy_to_clipboard"

import { INVOICE_ICON, formatDay } from "../PaymentDetail/helpers"
import InvoiceActionsMenu from "./InvoiceActionsMenu"
import { useInvoiceTracker } from "./useInvoiceTracker"

const InvoiceHeader = ({ invoice }) => {
  const copyToClipboard = useCopyToClipboard()
  const track = useInvoiceTracker()
  const { label, color } = getPaymentStatusBadgeProps(invoice.statusLabel)
  const details = [
    invoice.contactName,
    `Due ${formatDay(invoice.dueOn)}`,
    invoice.paymentMethodLabel,
    invoice.paidOn && `Paid ${formatDay(invoice.paidOn)}`,
  ]

  const copyId = () => {
    track("copy_id_pressed")
    copyToClipboard(invoice.id, "Invoice ID copied")
  }

  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-gray-300">
          <i
            className={`${INVOICE_ICON} text-2xl text-blue-600`}
            aria-hidden="true"
          />
        </div>
        <div>
          <div className="flex flex-wrap items-center gap-3">
            <div className="flex items-center gap-1">
              <h1 className="m-0 text-2xl font-bold text-gray-900">
                {invoice.displayId}
              </h1>
              <Tooltip text="Copy invoice ID" variant="dark">
                <Button
                  variant="ghost-tertiary"
                  icon="fa-copy"
                  iconStyle="regular"
                  iconOnly
                  small
                  title="Copy invoice ID"
                  onClick={copyId}
                />
              </Tooltip>
            </div>
            <Badge text={label} color={color} />
          </div>
          <p className="m-0 mt-1 text-sm text-gray-700">
            <a href={invoice.sourcePath}>{invoice.kindLabel}</a>
            {" · "}
            {details.filter(Boolean).join(" · ")}
          </p>
        </div>
      </div>
      <SideSheet.HeaderActions>
        <InvoiceActionsMenu invoice={invoice} />
      </SideSheet.HeaderActions>
    </header>
  )
}

InvoiceHeader.propTypes = {
  invoice: PropTypes.shape({
    id: PropTypes.string.isRequired,
    displayId: PropTypes.string.isRequired,
    statusLabel: PropTypes.string.isRequired,
    dueOn: PropTypes.string.isRequired,
    paidOn: PropTypes.string,
    kindLabel: PropTypes.string.isRequired,
    sourcePath: PropTypes.string.isRequired,
    contactName: PropTypes.string,
    paymentMethodLabel: PropTypes.string.isRequired,
  }).isRequired,
}

export default InvoiceHeader
